import { Pipe, PipeTransform } from '@angular/core';
import { ClientType } from 'src/app/back-office/clients-accounts/client-type';
import { NodeType } from 'src/app/planning/filters/common/node-type';

@Pipe({
  name: 'nodeIcon',
})
export class NodeIconPipe implements PipeTransform {
  transform(nodeType: NodeType, clientType: ClientType): string {
    switch (nodeType) {
      case NodeType.Site:
        return 'place';
      case NodeType.Building:
        return clientType === ClientType.SmartBuilding ? 'apartment' : 'store';
      case NodeType.MediaPlayer:
        return 'smart_display';
      default:
        return 'report_problem';
    }
  }
}
